import React, { Component } from 'react'
import {Helmet} from 'react-helmet'

import NavBar from '../../components/NavBar';
import PastCompetitionData from '../../components/PastCompetitionData';

import { Container, Row, Col, Image } from 'react-bootstrap';

export default class PastCompetition2018 extends Component {
    render() {
        return (
            <div>
                <Helmet>
                    <title>ISSC | The 2018 Competition</title>
                </Helmet>
                <NavBar hasHero={false} />
                <br />
                <Container>
                    <Row>
                        <Col>
                            <h1>The 2018 Competition</h1>
                        </Col>
                    </Row>
                    <PastCompetitionData teams="8" physicsTopic="Water Rocket" chemistryTopic="Soap" winner="ABCIS" />
                    <Row>
                        <Col lg="4 auto">
                            <Image alt="Students Collaborating" src="https://firebasestorage.googleapis.com/v0/b/issc-vn.appspot.com/o/images%2Fcolaberation.jpg?alt=media&token=ca57e910-d220-4b0c-9790-7d207f1b803e" rounded fluid />
                        </Col>
                        <Col>
                            <p>
                                In 2018, similar to previous years, there were 8 teams of international students who 
                                work together for six months to prepare science products that can help benefit our 
                                modern life. Not only so, but the students were also able to gain new skills that 
                                would help them with further studies, including leadership, communication, 
                                innovation, and decision-making.
                            </p> 
                            <p>
                                There were three prizes for the winning teams: top product for physics, top product 
                                for chemistry and top product for both areas. The physics topic was a water rocket 
                                where teams were asked to aim for the longest distance after launch. The chemistry 
                                topic was soap, relating to sodium acetate and similar compounds.
                            </p>
                            <p>
                                A team from Anglophone British Curriculum International School won all three prizes 
                                and received the prize of $500USD from our kind sponsors. Nonetheless, the emphasis 
                                of the competition is on the process of collaborating and creating a new product 
                                outside of the classroom. As the host of the competition, we hope that every team 
                                was able to work on their passions and have fun experiences with their team members.
                            </p>
                        </Col>
                    </Row>
                </Container>
                <br />
                <br />
            </div>
        )
    }
}
